module.exports = __webpack_public_path__ + "images/iphone-049cc8.png";